module.exports = __webpack_public_path__ + "static/img/static-zoom-county-0.067b90f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/static-zoom-county-0.png
// module id = 72
// module chunks = 0